import React from 'react';
import { apiRequest } from '../actions/apiActions';
import { showLoading, hideLoading, addUiMsg } from '../actions/uiActions';
import { apiUrls, apiVersion } from '../../apiUrls';
import {
  GET_CURRENT_USER_INFO,
  PROCESS_CURRENT_USER_INFO,
  CURRENT_USER_ERROR,
} from '../actions/currentUserActions';
import { processUser } from '../actions/userActions';
import { FormattedMessage } from 'react-intl';
import { errorDisplay } from '../../utilities/general';
import { messageTypes } from '../../components/ui/AlertMessage';

/**
 * Get the currently logged in user's full user object
 *
 * Sends an api call to the currentUser api endpoint and triggers
 * the show loading redux action.
 */
export const getCurrentUserInfo = (store) => (next) => (action) => {
  next(action);
  if (action.type === GET_CURRENT_USER_INFO) {
    const body = store.getState().auth.token;
    //Hit the API if there is an auth token
    if (body) {
      const meta = {
        method: 'GET',
        url: apiUrls.baseUrl + apiVersion + apiUrls[apiVersion].currentUser,
        onSuccess: PROCESS_CURRENT_USER_INFO,
        onError: CURRENT_USER_ERROR,
        auth: store.getState().auth.token,
        body: false,
        units: action.payload,
      };
      store.dispatch(showLoading());
      store.dispatch(apiRequest(body, meta));
    }
  }
};

/**
 * Process the incoming currently logged in user info
 *
 * The process current user info action is also used to trigger the current
 * user reducer to insert the current user data into Redux. This middleware
 * intercepts the action to also insert the currently installed user's data
 * into the users object and trigger the hide loading redux action.
 */
export const processCurrentUserInfo = ({ dispatch }) => (next) => (action) => {
  next(action);
  if (action.type === PROCESS_CURRENT_USER_INFO) {
    dispatch(processUser(action.payload));
    dispatch(hideLoading());
  }
};

/**
 * Middleware to process if an error occurs during the api request
 */
export const currentUserError = (store) => (next) => (action) => {
  next(action);
  if (action.type === CURRENT_USER_ERROR) {
    store.dispatch(hideLoading());
    const messageText = (
      <React.Fragment>
        <FormattedMessage
          id="currentUserMiddleware.errorText"
          defaultMessage="There was an error"
          description="The user statuses were not able to be loaded"
        />
      </React.Fragment>
    );
    const errors = action.payload;
    const message = {
      message: messageText,
      error: errorDisplay(errors),
      messageType: messageTypes.danger,
    };

    store.dispatch(addUiMsg(message));
  }
};

export const currentUserMdl = [
  getCurrentUserInfo,
  processCurrentUserInfo,
  currentUserError,
];
